import React from 'react';
import { findIndex } from 'underscore';
import clone from 'clone';
import Select from 'react-select';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import ReactToggle from 'react-toggle';
import { stringify } from '../../helper/helperFunction';

class TextBoxPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.saveData = this.saveData.bind(this);
      this.handleChangeToogleViewTypes = this.handleChangeToogleViewTypes.bind(this);
      this.toogleviewtype = [
        {
          'label': 'Toogle Show On',
          'value': 'true',
        },
        {
          'label': 'Toogle Show Off',
          'value': 'false',
        },
      ];
      this.settings = {};
    }
    componentWillMount() {
      this.settings = { ...this.props.settings };
      this.setState({
        'settings': { ...this.props.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...nextProps.settings },
        });
        this.settings = {};
      }
    }
    handelTitle(e) {
      this.settings.title = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelSubTitle(e) {
      this.settings.subtitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleChangeToogleViewTypes(val) {
      this.settings.selectedToogleViewType = val.target.checked;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleClassName(e) {
      this.settings.dynamicNameClassTextBox = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.APPEARANCE}</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.title)} onChange= { this.handelTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_TITLE}/>
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.subtitle)} onChange= { this.handelSubTitle.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_SUBTITLE}/>

              <input type="text" className="reactive-input" value = {this.state.settings.dynamicNameClassTextBox} onChange= { this.handleClassName.bind(this) } placeholder={API.LANG.PLEASE_ENTER_THE_CUSTOM_CSS_CLASSNAME}/>

              <div className="grid-choose-option">
                <div className="flex-row ">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.TOGGLE_OPTION}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <ReactToggle
                        defaultChecked={this.state.settings.selectedToogleViewType === 'true' || this.state.settings.selectedToogleViewType === true}
                        onChange={this.handleChangeToogleViewTypes.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="populate">
            </div>
          </div>
        </div>

      </div>);
    }
}


TextBoxPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default TextBoxPanel;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/panel/search/textboxPanel.js
 **/